import styled from "styled-components";

export const TagValueInputContainer = styled.div`
  width: 100%;

  .tag-label {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .label-text {
      color: ${(props) => props.theme.colors.tertiary};
    }

    .clear-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.4rem;
      height: 2.4rem;

      svg {
        width: 1.8rem;
        fill: ${(props) => props.theme.colors.tertiary};
        transform: rotate(45deg);
      }
    }
  }

  .tag-input-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    padding: 1.2rem 1.6rem;
    border: 1px solid ${(props) => props.theme.colors.elements};
    border-radius: 16px;
    background: ${(props) => props.theme.colors.white};
    min-height: 4.8rem;
    cursor: text;
    transition: border-color 0.2s;

    &:focus-within {
      border-color: ${(props) => props.theme.colors.primary};
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.disabled.swatch-editavel {
      opacity: 1;
      cursor: default;

      .tag-text-input {
        opacity: 0.5;
      }
    }
  }

  .tag-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.4rem 1rem;
    border-radius: 16px;
    background: ${(props) => props.theme.colors.elements};
    color: ${(props) => props.theme.colors.tertiary};
    white-space: nowrap;

    .tag-diamond {
      width: 2.8rem;
      fill: ${(props) => props.theme.colors.primary};
    }

    /* Ocupa o mesmo espaço do tag-diamond que substitui, para o chip não pular
       de largura quando a variação ganha ou perde um swatch. */
    .tag-swatch {
      width: 2.8rem;
      height: 2.8rem;
      border-radius: 50%;
      display: block;
      object-fit: cover;
      /* Borda sutil para cores claras não sumirem no fundo do chip. */
      border: 1px solid ${(props) => props.theme.colors.elements};
    }

    .tag-text {
      cursor: default;
    }

    .tag-edit-input {
      border: none;
      outline: none;
      background: transparent;
      color: inherit;
      font-size: inherit;
      font-family: inherit;
      max-width: 14rem;
      padding: 0;

      @media (max-width: 768px) {
        max-width: 12rem;
      }
    }

    .tag-remove {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.6rem;
      height: 1.6rem;
      border-radius: 50%;
      transition: background 0.2s;

      svg {
        width: 1.6rem;
        height: 1.6rem;
        fill: ${(props) => props.theme.colors.tertiary};
        transform: rotate(45deg);
      }

      &:hover {
        background: ${(props) => props.theme.colors.skeleton2};
      }
    }
  }

  .ghost-input-wrapper {
    position: relative;
    flex: 1;
    min-width: 8rem;
    display: inline-flex;
    align-items: center;
    min-height: 2.4rem;
  }

  .tag-text-input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-family: inherit;
    color: ${(props) => props.theme.colors.tertiary};
    position: relative;
    z-index: 1;
    padding: 0;
    margin: 0;

    &::placeholder {
      color: ${(props) => props.theme.colors.disable};
      font-size: 12px;
      transform: translateY(-1px);

      @media (max-width: 768px) {
        font-size: 10px;
      }
    }
  }

  .ghost-text {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    white-space: nowrap;
    color: ${(props) => props.theme.colors.disable};
    opacity: 0.5;
    z-index: 0;
    font-family: inherit;
    font-size: inherit;
  }

  .tag-helper {
    margin-top: 0.8rem;
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
  }
`;
